<template>
  <div>
    <navigation-bar Close/>
    <div class="main issue">
      <el-row type="flex" justify="end" class="filter">
        <div class="sort_bar" @click="changeSort()">
          <span>{{sortText}}</span>
        </div>
      </el-row>
      <category-content v-for="(item, index) in list" :key="index">
        <el-row type="flex" justify="space-between">
          <el-col :span="18" class="date text-left">
            <span style="margin-right: 20px">{{item.createdAt}}</span>
            <!-- <span>18:00</span> -->
          </el-col>
          <el-col :span="6" class="text-right">
            <span class="amount">{{'x'+ item.count}}</span>
          </el-col>
        </el-row>
        <div class="store text-left">
          {{'發放：'+ item.storeName}}
        </div>
      </category-content>
      <infinite-loading v-if="setupData" spinner="waveDots" @infinite="setupDataScroll">
        <div slot="no-more">沒有更多資料</div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <loading
        :active.sync=isLoading
        :can-cancel="false"
        :is-full-page="true">
    </loading>
  </div>
</template>

<script>

const isNear = 0;
const isFar = 1;

import CategoryContent from '@/components/category/Content.vue'

export default {
    name: "IssueDate",
    props: {
      isWeb: Boolean,
      dataTokenWeb: {default: ''},
    },
    components: {
        CategoryContent
    },
    data() {
        return {
            dataToken: this.isWeb? (this.dataTokenWeb.dataToken || "") : (this.$route.query.dataToken || ""),
            dataObject: {},
            id: this.isWeb ? this.dataTokenWeb.couponId :this.$route.params.couponId,
            list: [],
            orderBy: 0,
            sortText: '由近到遠',
            isLoading: false,
            pageSize: 10,
            currentPage: 0,
            setupData: false,
            infiniteLoadingState: '',
        }
    },
    created() {
        try {
            this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)

            if (!this.$public.notNull(this.id) && this.dataObject.usedType === 'IssueDate' && this.dataObject.id > 0) {
                this.id = this.dataObject.id
            }
        } catch (e) {
            this.dataObject = {}
        }

        this.setupData = true;
    },
    mounted() {

    },
    methods: {
        setupDataScroll($state) {
            let self = this;
            this.isLoading = true;
            this.infiniteLoadingState = $state;
            this.$http.fetchWithAuthEncrypt`CouponUsePublishDateList${{
                id: parseInt(this.id),
                offset: this.currentPage,
                orderBy: this.orderBy
            }}
            ${json => {
                if (json.data.length >= self.pageSize) {
                    self.currentPage++;
                    self.list.push(...json.data);
                    $state.loaded();
                } else {
                    self.currentPage++;
                    self.list.push(...json.data);
                    $state.complete();
                }
                this.isLoading = false;
            }}`;
        },
        changeSort() {
            if (this.orderBy === isNear) {
                this.orderBy = isFar;
                this.sortText = '由遠到近';
            } else {
                this.orderBy = isNear;
                this.sortText = '由近到遠';
            }
            this.currentPage = 0;
            this.list = [];
            this.infiniteLoadingState.reset();
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .content {
  padding: 12px 0px
}
.issue {
  padding: 20px;
}
.filter {
  margin-bottom: 15px;
  img {width: 75px;}
}
.date {
  color: #C1AE8A
}
.amount {
  color: #E37E84;
  font-size: 14px;
}
.store {
  color: #474645;
  font-size: 16px;
}
</style>